import { Directive, EventEmitter, Input, Output } from '@angular/core';
import {
  TableCell,
  TableCellAttribute,
  TableCellOnActionEvent,
  TableRowData,
} from 'src/app/interfaces/tables.interfaces';
import { AccountStatus } from 'src/app/swagger-api';
import { CellActionTooltipValues, CellActionTypes } from './components/cell-actions.type';
import { builTableElementTestId } from './table.helpers';

@Directive()
export class TableCellState implements TableCell {
  @Input({ required: true }) public tableRowData: TableRowData;
  @Input({ required: true }) public tableCellAttribute: TableCellAttribute;
  @Input({ required: true }) public rowIndex: number;
  @Input({ required: true }) public cellIndex: number;

  @Input({ required: false }) public isExpired = false;
  @Input({ required: false }) public redirectToLoginIfNoSession = false;
  @Input({ required: false }) public tooltipValues: CellActionTooltipValues;

  @Output() public action: EventEmitter<TableCellOnActionEvent> = new EventEmitter<TableCellOnActionEvent>();

  public readonly CellActionTypes: typeof CellActionTypes = CellActionTypes;

  public buildActionButtonTestId(type: CellActionTypes): string {
    return builTableElementTestId(type, this.rowIndex, this.cellIndex);
  }

  public get deactivated(): boolean {
    if (this.tableRowData.entity) {
      return this.tableRowData.entity?.creator.account_status === AccountStatus.DEACTIVATED;
    } else {
      return this.tableRowData.user?.account_status === AccountStatus.DEACTIVATED;
    }
  }

  public tooltipDescription(type: CellActionTypes): string {
    return this.tooltipValues?.[type] ?? '';
  }

  public onAction(type: CellActionTypes): void {
    this.action.emit({
      type,
      entityId: this.tableRowData.entityId,
      actorId: this.tableRowData.actorId,
      cellPosition: { rowIndex: this.rowIndex, cellIndex: this.cellIndex },
    });
  }
}
